import type { AgentDeploymentExtension as AgentDeploymentExtensionModel } from '@/adapters/catalogv1.g';

export function extractAgentDeploymentExtension(
  model: AgentDeploymentExtensionModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deploymentRef: model.deployment_ref ?? '',
    // Summarised as a count: the chunk is unbounded, and the individual values
    // are readable as agent deployment attributes.
    attributeCount: model.attributes?.length ?? 0,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentDeploymentExtension = ReturnType<
  typeof extractAgentDeploymentExtension
>;
